import { gql, useMutation } from '@phoenix-web/ux-gql/apollo'

export type ConsumeInviteTokenBody = {
  token?: string
}

export const CONSUME_INVITE_TOKEN = gql`
  mutation ConsumeInviteToken($input: ConsumeInviteTokenBody!) {
    consumeInviteToken(input: $input) {
      success
    }
  }
`

export const useConsumeInviteToken = ({ skip: _skip = false }: { skip?: boolean } = {}) => {
  const query = useMutation(CONSUME_INVITE_TOKEN, { fetchPolicy: 'no-cache' })
  return query
}
